/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M10.1938 9.06421L8.48286 11.0196C7.37665 12.2838 6.82355 12.9159 6.80642 13.4521C6.79153 13.918 6.99405 14.3643 7.35445 14.6598C7.76923 15 8.60917 15 10.289 15H13.711C15.3908 15 16.2308 15 16.6455 14.6598C17.0059 14.3643 17.2085 13.918 17.1936 13.4521C17.1765 12.9159 16.6233 12.2838 15.5171 11.0196L13.8062 9.06421C13.1826 8.35151 12.8708 7.99515 12.5013 7.86415C12.177 7.74913 11.823 7.74913 11.4987 7.86415C11.1292 7.99515 10.8174 8.35151 10.1938 9.06421Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22 10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10ZM10.289 15C8.60917 15 7.76923 15 7.35445 14.6598C6.99405 14.3643 6.79153 13.918 6.80642 13.4521C6.82355 12.9159 7.37665 12.2838 8.48286 11.0196L10.1938 9.06421C10.8174 8.35151 11.1292 7.99515 11.4987 7.86415C11.823 7.74913 12.177 7.74913 12.5013 7.86415C12.8708 7.99515 13.1826 8.35151 13.8062 9.06421L15.5171 11.0196C16.6233 12.2838 17.1765 12.9159 17.1936 13.4521C17.2085 13.918 17.0059 14.3643 16.6455 14.6598C16.2308 15 15.3908 15 13.711 15H10.289Z"
				fill="currentColor"
			/>
			<path
				d="M2 10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V10Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.8062 9.06421C13.1826 8.35151 12.8708 7.99515 12.5013 7.86415C12.177 7.74913 11.823 7.74913 11.4987 7.86415C11.1292 7.99515 10.8174 8.35151 10.1938 9.06421L8.48286 11.0196C7.37665 12.2838 6.82355 12.9159 6.80642 13.4521C6.79153 13.918 6.99405 14.3643 7.35445 14.6598C7.76923 15 8.60917 15 10.289 15H13.711C15.3908 15 16.2308 15 16.6455 14.6598C17.0059 14.3643 17.2085 13.918 17.1936 13.4521C17.1765 12.9159 16.6233 12.2838 15.5171 11.0196L13.8062 9.06421Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM9.09699 10.903L10.3029 9.69707C10.8969 9.10305 11.1939 8.80604 11.5364 8.69475C11.8377 8.59687 12.1622 8.59687 12.4635 8.69475C12.806 8.80604 13.103 9.10305 13.697 9.69707L13.697 9.69707L14.9029 10.903C16.188 12.1881 16.8306 12.8307 16.874 13.3823C16.9117 13.861 16.7179 14.3288 16.3528 14.6406C15.932 15 15.0233 15 13.2058 15H10.794C8.9766 15 8.06788 15 7.64708 14.6406C7.28197 14.3288 7.08821 13.861 7.12588 13.3823C7.1693 12.8307 7.81186 12.1881 9.09699 10.903Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 22H9V22C7.13872 22 6.20808 22 5.45492 21.7553C3.93273 21.2607 2.73931 20.0673 2.24472 18.5451C2 17.7919 2 16.8613 2 15V10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V15C22 16.8613 22 17.7919 21.7553 18.5451C21.2607 20.0673 20.0673 21.2607 18.5451 21.7553C17.7919 22 16.8613 22 15 22V22H14.5M15.5171 11.0196L13.8062 9.06421C13.1826 8.35151 12.8708 7.99515 12.5013 7.86415C12.177 7.74913 11.823 7.74913 11.4987 7.86415C11.1292 7.99515 10.8174 8.35151 10.1938 9.06421L8.48286 11.0196C7.37665 12.2838 6.82355 12.9159 6.80642 13.4521C6.79153 13.918 6.99405 14.3643 7.35445 14.6598C7.76923 15 8.60917 15 10.289 15H13.711C15.3908 15 16.2308 15 16.6455 14.6598C17.0059 14.3643 17.2085 13.918 17.1936 13.4521C17.1765 12.9159 16.6233 12.2838 15.5171 11.0196Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2 10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V10Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.8062 9.06421C13.1826 8.35151 12.8708 7.99515 12.5013 7.86415C12.177 7.74913 11.823 7.74913 11.4987 7.86415C11.1292 7.99515 10.8174 8.35151 10.1938 9.06421L8.48286 11.0196C7.37665 12.2838 6.82355 12.9159 6.80642 13.4521C6.79153 13.918 6.99405 14.3643 7.35445 14.6598C7.76923 15 8.60917 15 10.289 15H13.711C15.3908 15 16.2308 15 16.6455 14.6598C17.0059 14.3643 17.2085 13.918 17.1936 13.4521C17.1765 12.9159 16.6233 12.2838 15.5171 11.0196L13.8062 9.06421Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				d="M10.3027 9.69707L9.09684 10.903C7.81171 12.1881 7.16914 12.8307 7.12573 13.3823C7.08805 13.861 7.28182 14.3288 7.64693 14.6406C8.06772 15 8.97645 15 10.7939 15H13.2057C15.0231 15 15.9318 15 16.3526 14.6406C16.7177 14.3288 16.9115 13.861 16.8738 13.3823C16.8304 12.8307 16.1879 12.1881 14.9027 10.903L13.6968 9.69707L13.6968 9.69707C13.1028 9.10305 12.8058 8.80604 12.4633 8.69475C12.162 8.59687 11.8375 8.59687 11.5363 8.69475C11.1938 8.80604 10.8968 9.10305 10.3027 9.69707Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
